module.exports = __webpack_public_path__ + "img/part4txt.82ff0cc7.png";